/** number of each shop content type to fetch for their 'all' page sliders */
export const SLIDER_ITEMS_PER_FETCH = 12;
